import LancamentoDespesaService from "../../services/resource/lancamentoDespesaService";
import SolicitacaoCompraService from "../../services/resource/solicitacaoCompraService";
import MultaService from "../../services/resource/multaService";
import PromocaoFuncionarioService from "../../services/resource/promocaoFuncionarioService";
import DesligamentoService from "../../services/resource/desligamentoService";
import SolicitacaoPessoalService from "../../services/resource/solicitacaoPessoalService";
import ChamadoTIService from "../../services/resource/chamadoTIService";
import RecolhimentoAtivosService from "../../services/resource/recolhimentoAtivosService";
import SolicitacaoAtivosService from "../../services/resource/solicitacaoAtivosService";
import AnaliseLimitePrazoService from "../../services/resource/analiseLimitePrazoService";
import CadastroClienteService from "../../services/resource/cadastroClienteService";
import AjusteGtcService from "../../services/resource/ajusteGtcService";
import RenovacaoGdmService from "../../services/resource/renovacaoGdmService";

import NovaSolicitacaoDespesaForm from "../../components/solicitacoes/FormEtapas/despesa/NovaSolicitacaoDespesaForm";
import NovaSolicitacaoComprasForm from "../../components/solicitacoes/FormEtapas/compras/NovaSolicitacaoComprasForm";
import NovaSolicitacaoMultasForm from "../../components/solicitacoes/FormEtapas/multas/NovaSolicitacaoMultasForm";
import NovaSolicitacaoPromocaoForm from "../../components/solicitacoes/FormEtapas/promocao/NovaSolicitacaoPromocaoForm";
import NovaSolicitacaoDesligamentoForm from "../../components/solicitacoes/FormEtapas/desligamento/NovaSolicitacaoDesligamentoForm";
import NovaSolicitacaoPessoalForm from "../../components/solicitacoes/FormEtapas/solicitacaopessoal/NovaSolicitacaoPessoalForm";
import NovaChamadoTIForm from "../../components/solicitacoes/FormEtapas/chamadoti/NovaChamadoTIForm";
import NovaSolicitacaoRecolhimentoForm from "../../components/solicitacoes/FormEtapas/recolhimentoativos/NovaSolicitacaoRecolhimentoForm";
import NovaSolicitacaoAtivosForm from "../../components/solicitacoes/FormEtapas/solicitacaoativos/NovaSolicitacaoAtivosForm";
import NovaSolicitacaoLimitePrazoForm from "../../components/solicitacoes/FormEtapas/limiteprazo/NovaSolicitacaoLimitePrazoForm";
import NovaSolicitacaoCadastroClienteForm from "../../components/solicitacoes/FormEtapas/cadastrocliente/NovaSolicitacaoCadastroClienteForm";
import NovaSolicitacaoAjusteGtcForm from "../../components/solicitacoes/FormEtapas/ajustegtc/NovaSolicitacaoAjusteGtcForm";
import NovaSolicitacaoRenovacaoGdmForm, { DOCUMENTOS_OBRIGATORIOS_RENOVACAO_GDM, ETAPAS_RENOVACAO_GDM } from "../../components/solicitacoes/FormEtapas/renovacaogdm/NovaSolicitacaoRenovacaoGdmForm";

import EtapaSolicitacaoRetificada from "../../components/solicitacoes/FormEtapas/shared/EtapaSolicitacaoRetificada";
import EtapaCompraSolicitacaoRetificada from "../../components/solicitacoes/FormEtapas/compras/EtapaCompraSolicitacaoRetificada";
import EtapaDespesaSolicitacaoRetificada from "../../components/solicitacoes/FormEtapas/despesa/EtapaDespesaSolicitacaoRetificada";
import EtapaSomenteAcoes from "../../components/solicitacoes/FormEtapas/shared/EtapaSomenteAcoes";
import EtapaLancamentoFortes from "../../components/solicitacoes/FormEtapas/shared/EtapaLancamentoFortes";
import EtapaDigitacaoAtivos from "../../components/solicitacoes/FormEtapas/shared/EtapaDigitacaoAtivos";
import EtapaAprovacaoGestor from "../../components/solicitacoes/FormEtapas/shared/EtapaAprovacaoGestor";
import EtapaAprovacaoComEscolha from "../../components/solicitacoes/FormEtapas/shared/EtapaAprovacaoComEscolha";
import EtapaConfirmacaoPagamento from "../../components/solicitacoes/FormEtapas/shared/EtapaConfirmacaoPagamento";
import EtapaCotacao from "../../components/solicitacoes/FormEtapas/compras/EtapaCotacao";
import EtapaOrdemCompra from "../../components/solicitacoes/FormEtapas/compras/EtapaOrdemCompra";
import EtapaRecebimento from "../../components/solicitacoes/FormEtapas/compras/EtapaRecebimento";
import EtapaMultaAnalise from "../../components/solicitacoes/FormEtapas/multas/EtapaMultaAnalise";
import EtapaMultaReconhecimento from "../../components/solicitacoes/FormEtapas/multas/EtapaMultaReconhecimento";
import EtapaMultaConfirmacao from "../../components/solicitacoes/FormEtapas/multas/EtapaMultaConfirmacao";
import EtapaMultaPagamento from "../../components/solicitacoes/FormEtapas/multas/EtapaMultaPagamento";
import EtapaPromocaoAnalise from "../../components/solicitacoes/FormEtapas/promocao/EtapaPromocaoAnalise";
import EtapaCadastroClienteFinanceiro from "../../components/solicitacoes/FormEtapas/cadastrocliente/EtapaCadastroClienteFinanceiro";
import EtapaLimitePrazoAnaliseFinanceiro from "../../components/solicitacoes/FormEtapas/limiteprazo/EtapaLimitePrazoAnaliseFinanceiro";
import EtapaSolicitacaoPessoalAnaliseRH from "../../components/solicitacoes/FormEtapas/solicitacaopessoal/EtapaSolicitacaoPessoalAnaliseRH";
import EtapaChamadoTIAnalise from "../../components/solicitacoes/FormEtapas/chamadoti/EtapaChamadoTIAnalise";
import EtapaAjusteGtcCadastroAlteracao from "../../components/solicitacoes/FormEtapas/ajustegtc/EtapaAjusteGtcCadastroAlteracao";
import EtapaRenovacaoGdmSolicitacao from "../../components/solicitacoes/FormEtapas/renovacaogdm/EtapaRenovacaoGdmSolicitacao";
import EtapaRenovacaoGdmAprovacao from "../../components/solicitacoes/FormEtapas/renovacaogdm/EtapaRenovacaoGdmAprovacao";
import EtapaRenovacaoGdmConfirmacao from "../../components/solicitacoes/FormEtapas/renovacaogdm/EtapaRenovacaoGdmConfirmacao";

import DetalheDespesa from "../../components/solicitacoes/DetalheProcesso/DetalheDespesa";
import DetalheCompras from "../../components/solicitacoes/DetalheProcesso/DetalheCompras";
import DetalheMulta from "../../components/solicitacoes/DetalheProcesso/DetalheMulta";
import DetalhePromocao from "../../components/solicitacoes/DetalheProcesso/DetalhePromocao";
import DetalheDesligamento from "../../components/solicitacoes/DetalheProcesso/DetalheDesligamento";
import DetalheSolicitacaoPessoal from "../../components/solicitacoes/DetalheProcesso/DetalheSolicitacaoPessoal";
import DetalheChamadoTI from "../../components/solicitacoes/DetalheProcesso/DetalheChamadoTI";
import DetalheRecolhimentoAtivos from "../../components/solicitacoes/DetalheProcesso/DetalheRecolhimentoAtivos";
import DetalheSolicitacaoAtivos from "../../components/solicitacoes/DetalheProcesso/DetalheSolicitacaoAtivos";
import DetalheLimitePrazo from "../../components/solicitacoes/DetalheProcesso/DetalheLimitePrazo";
import DetalheCadastroCliente from "../../components/solicitacoes/DetalheProcesso/DetalheCadastroCliente";
import DetalheAjusteGtc from "../../components/solicitacoes/DetalheProcesso/DetalheAjusteGtc";
import DetalheRenovacaoGdm from "../../components/solicitacoes/DetalheProcesso/DetalheRenovacaoGdm";

/**
 * Ponto único de extensão do módulo: cada tipo de processo cadastrado aqui informa suas etapas
 * (código + rótulo, na ordem — necessário para desenhar EtapaProgress/colunas do Kanban, já que
 * o backend só expõe a etapa ATUAL, não a lista completa), o service específico para buscar o
 * detalhe do processo, o formulário de criação e o componente de cada etapa. Nenhuma regra de
 * aprovação/transição mora aqui — só rotulagem e "qual componente desenhar". Um processo novo
 * só precisa de uma entrada nova aqui + seus componentes de formulário, sem tocar em mais nada.
 */
export const PROCESSO_REGISTRY = {
    LANCAMENTO_DESPESA: {
        label: "Lançamento de Despesa",
        icone: "fa fa-receipt",
        service: new LancamentoDespesaService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoDespesaForm,
        detalheComponent: DetalheDespesa,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_APROVACAO", label: "Aprovação" },
            { codigo: "ETAPA_3_CONFIRMACAO_LANCAMENTO", label: "Lançamento" },
            { codigo: "ETAPA_4_CONFIRMACAO_PAGAMENTO", label: "Pagamento" },
            { codigo: "ETAPA_5_REGULARIZACAO_DOCUMENTACAO", label: "Regular Documentação" },
            { codigo: "ETAPA_6_CONFIRMACAO_BAIXA_PAGAMENTO", label: "Confirmação da Baixa" },
        ],
        // Etapas 5 e 6 só existem quando a Confirmação de Pagamento aponta pendência — no fluxo
        // feliz (pagamento confirmado de primeira) o EtapaProgress não deve mostrá-las. O flag
        // `pendenciaPagamento` nunca reverte (ver backend), então continua mostrando as 2 etapas
        // mesmo depois de a solicitação já ter sido finalizada por esse caminho.
        // Contas a Pagar não passa por Lançamento, e a Aprovação some quando o solicitante escolheu a
        // si mesmo como aprovador (`aprovacaoDispensada`) — ver EtapaDespesaSolicitacaoHandler/AprovacaoHandler.
        etapasParaExibir: detalheProcesso => {
            const ocultas = new Set();
            if (!detalheProcesso?.pendenciaPagamento) {
                ocultas.add("ETAPA_5_REGULARIZACAO_DOCUMENTACAO");
                ocultas.add("ETAPA_6_CONFIRMACAO_BAIXA_PAGAMENTO");
            }
            if (detalheProcesso?.tipoDespesa === "CONTAS_A_PAGAR") ocultas.add("ETAPA_3_CONFIRMACAO_LANCAMENTO");
            if (detalheProcesso?.aprovacaoDispensada) ocultas.add("ETAPA_2_APROVACAO");
            return PROCESSO_REGISTRY.LANCAMENTO_DESPESA.etapas.filter(e => !ocultas.has(e.codigo));
        },
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaDespesaSolicitacaoRetificada, props: {} },
            ETAPA_2_APROVACAO: { component: EtapaSomenteAcoes, props: { texto: "Analise a solicitação e aprove, reprove ou retifique." } },
            ETAPA_3_CONFIRMACAO_LANCAMENTO: { component: EtapaLancamentoFortes, props: { acaoConclusao: "CONFIRMAR", texto: "Confirme o lançamento contábil da despesa ou retifique para devolvê-la à etapa de Solicitação. Informe (ou sincronize) o código do lançamento gerado no Fortes, se tiver." } },
            ETAPA_4_CONFIRMACAO_PAGAMENTO: { component: EtapaConfirmacaoPagamento, props: {} },
            ETAPA_5_REGULARIZACAO_DOCUMENTACAO: { component: EtapaSomenteAcoes, props: { texto: "Corrija ou inclua os documentos necessários e confirme a regularização." } },
            ETAPA_6_CONFIRMACAO_BAIXA_PAGAMENTO: { component: EtapaSomenteAcoes, props: { texto: "Confirme se o pagamento já está regularizado, ou devolva para Regularização de Documentação caso ainda haja pendência." } },
        },
        sugestoes: ["Nota Fiscal", "Boleto", "XML"]
    },
    SOLICITACAO_COMPRAS: {
        label: "Solicitação de Compras",
        icone: "fa fa-shopping-cart",
        service: new SolicitacaoCompraService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoComprasForm,
        detalheComponent: DetalheCompras,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_APROVACAO_SOLICITACAO", label: "Aprovação" },
            { codigo: "ETAPA_3_COTACAO", label: "Cotação" },
            { codigo: "ETAPA_4_APROVACAO_CORPORATIVA", label: "Aprov. Corporativa" },
            { codigo: "ETAPA_5_APROVACAO_DIRETORIA", label: "Aprov. Diretoria" },
            { codigo: "ETAPA_6_ORDEM_COMPRA", label: "Ordem de Compra" },
            { codigo: "ETAPA_7_CONFIRMACAO_RECEBIMENTO", label: "Recebimento" },
            { codigo: "ETAPA_8_LANCAMENTO_NOTA", label: "Lanç. da Nota" },
            { codigo: "ETAPA_9_CONFIRMACAO_PAGAMENTO", label: "Pagamento" },
            { codigo: "ETAPA_10_REGULARIZACAO_DOCUMENTACAO", label: "Regular Documentação" },
            { codigo: "ETAPA_11_CONFIRMACAO_BAIXA_PAGAMENTO", label: "Confirmação da Baixa" },
        ],
        // Quando o solicitante marca "Necessita de cotação? = Não" na Etapa 1, o backend pula as
        // Etapas 2 (Aprovação) e 3 (Cotação) e vai direto para a Etapa 4 — o EtapaProgress não deve
        // mostrar essas duas etapas como concluídas/pendentes para essas solicitações. As etapas
        // 10/11 (desvio de pendência de pagamento) só aparecem depois que a solicitação de fato
        // passa por elas (mesmo padrão de LANCAMENTO_DESPESA).
        etapasParaExibir: detalheProcesso => {
            let etapas = PROCESSO_REGISTRY.SOLICITACAO_COMPRAS.etapas;
            if (detalheProcesso?.necessitaCotacao === false) {
                etapas = etapas.filter(e => e.codigo !== "ETAPA_2_APROVACAO_SOLICITACAO" && e.codigo !== "ETAPA_3_COTACAO");
            }
            if (!detalheProcesso?.pendenciaPagamento) {
                etapas = etapas.filter(e => e.codigo !== "ETAPA_10_REGULARIZACAO_DOCUMENTACAO" && e.codigo !== "ETAPA_11_CONFIRMACAO_BAIXA_PAGAMENTO");
            }
            return etapas;
        },
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaCompraSolicitacaoRetificada, props: {} },
            ETAPA_2_APROVACAO_SOLICITACAO: { component: EtapaSomenteAcoes, props: { texto: "Analise a solicitação e aprove, reprove ou retifique." } },
            ETAPA_3_COTACAO: { component: EtapaCotacao, props: {} },
            ETAPA_4_APROVACAO_CORPORATIVA: { component: EtapaAprovacaoComEscolha, props: {} },
            ETAPA_5_APROVACAO_DIRETORIA: { component: EtapaSomenteAcoes, props: { texto: "Aprovação da diretoria para valores mais altos." } },
            ETAPA_6_ORDEM_COMPRA: { component: EtapaOrdemCompra, props: {} },
            ETAPA_7_CONFIRMACAO_RECEBIMENTO: { component: EtapaRecebimento, props: {} },
            ETAPA_8_LANCAMENTO_NOTA: { component: EtapaLancamentoFortes, props: { acaoConclusao: "LANCADO", texto: "Confirme o lançamento da nota fiscal. Informe (ou sincronize) o código do lançamento gerado no Fortes, se tiver." } },
            ETAPA_9_CONFIRMACAO_PAGAMENTO: { component: EtapaConfirmacaoPagamento, props: {} },
            ETAPA_10_REGULARIZACAO_DOCUMENTACAO: { component: EtapaSomenteAcoes, props: { texto: "Corrija ou inclua a documentação necessária e confirme a regularização." } },
            ETAPA_11_CONFIRMACAO_BAIXA_PAGAMENTO: { component: EtapaSomenteAcoes, props: { texto: "Confirme se o pagamento já está regularizado ou devolva para nova regularização." } },
        },
    },
    PROCESSO_MULTAS: {
        label: "Processo de Multas",
        icone: "fa fa-exclamation-triangle",
        service: new MultaService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoMultasForm,
        detalheComponent: DetalheMulta,
        etapas: [
            { codigo: "ETAPA_1_CADASTRO", label: "Cadastro" },
            { codigo: "ETAPA_2_ANALISE", label: "Análise" },
            { codigo: "ETAPA_3_RECONHECIMENTO", label: "Reconhecimento" },
            { codigo: "ETAPA_4_CONFIRMACAO", label: "Confirmação" },
            { codigo: "ETAPA_5_PAGAMENTO", label: "Pagamento" },
        ],
        etapaComponents: {
            ETAPA_1_CADASTRO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE: { component: EtapaMultaAnalise, props: {} },
            ETAPA_3_RECONHECIMENTO: { component: EtapaMultaReconhecimento, props: {} },
            ETAPA_4_CONFIRMACAO: { component: EtapaMultaConfirmacao, props: {} },
            ETAPA_5_PAGAMENTO: { component: EtapaMultaPagamento, props: {} },
        },
         sugestoes: ["Termo de Responsabilidade", "Comprovante de Pagamento", "Boleto", "Auto de Infração", "Detalhe Infração", "Fotos"]
    },
    PROMOCAO_FUNCIONARIOS: {
        label: "Promoção, Enquadramento e Transferência",
        icone: "fa fa-user-graduate",
        service: new PromocaoFuncionarioService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoPromocaoForm,
        detalheComponent: DetalhePromocao,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_APROVACAO_GESTOR", label: "Aprovação do Gestor" },
            { codigo: "ETAPA_2_ANALISE", label: "Análise RH" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_APROVACAO_GESTOR: { component: EtapaAprovacaoGestor, props: {} },
            ETAPA_2_ANALISE: { component: EtapaPromocaoAnalise, props: {} },
        },
    },
    DESLIGAMENTO_PESSOAL: {
        label: "Desligamento de Pessoal",
        icone: "fa fa-user-slash",
        service: new DesligamentoService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoDesligamentoForm,
        detalheComponent: DetalheDesligamento,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_APROVACAO_GESTOR", label: "Aprovação do Gestor" },
            { codigo: "ETAPA_2_ANALISE", label: "Análise RH" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_APROVACAO_GESTOR: { component: EtapaAprovacaoGestor, props: {} },
            ETAPA_2_ANALISE: { component: EtapaPromocaoAnalise, props: {} },
        },
    },
    SOLICITACAO_PESSOAL: {
        label: "Solicitação de Pessoal (Funcionário)",
        icone: "fa fa-user-plus",
        service: new SolicitacaoPessoalService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoPessoalForm,
        detalheComponent: DetalheSolicitacaoPessoal,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_APROVACAO_DIRETORIA", label: "Aprovação da Diretoria" },
            { codigo: "ETAPA_3_ANALISE_RH", label: "Análise do RH" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_APROVACAO_DIRETORIA: { component: EtapaSomenteAcoes, props: { texto: "Analise a solicitação de pessoal e aprove ou reprove." } },
            ETAPA_3_ANALISE_RH: { component: EtapaSolicitacaoPessoalAnaliseRH, props: {} },
        },
    },
    ABERTURA_CHAMADO_TI: {
        label: "Abertura de Chamado TI",
        icone: "fa fa-headset",
        service: new ChamadoTIService(),
        temDetalhe: true,
        formularioCriacao: NovaChamadoTIForm,
        detalheComponent: DetalheChamadoTI,
        etapas: [
            { codigo: "ETAPA_1_ABERTURA", label: "Abertura do Chamado" },
            { codigo: "ETAPA_2_ANALISE_TI", label: "Análise da TI" },
        ],
        etapaComponents: {
            ETAPA_1_ABERTURA: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE_TI: { component: EtapaChamadoTIAnalise, props: {} },
        },
    },
    RECOLHIMENTO_ATIVOS: {
        label: "Recolhimento de Ativos",
        icone: "fa fa-dolly",
        service: new RecolhimentoAtivosService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoRecolhimentoForm,
        detalheComponent: DetalheRecolhimentoAtivos,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_ANALISE", label: "Análise do Supervisor" },
            { codigo: "ETAPA_3_DIGITACAO", label: "Digitação" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE: { component: EtapaPromocaoAnalise, props: {justificativa: "De acordo!"} },
            ETAPA_3_DIGITACAO: { component: EtapaDigitacaoAtivos, props: { texto: "Informe como ficou a digitação do pedido de recolhimento." } },
        },
    },
    SOLICITACAO_ATIVOS: {
        label: "Solicitação de Ativos",
        icone: "fa fa-box-open",
        service: new SolicitacaoAtivosService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoAtivosForm,
        detalheComponent: DetalheSolicitacaoAtivos,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_ANALISE", label: "Análise do Supervisor" },
            { codigo: "ETAPA_3_DIGITACAO", label: "Digitação" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE: { component: EtapaPromocaoAnalise, props: {justificativa: "De acordo!"} },
            ETAPA_3_DIGITACAO: { component: EtapaDigitacaoAtivos, props: { texto: "Informe como ficou a digitação do pedido do ativo." } },
        },
    },
    ANALISE_LIMITE_PRAZO: {
        label: "Análise de Limite e Prazo",
        icone: "fa fa-balance-scale",
        service: new AnaliseLimitePrazoService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoLimitePrazoForm,
        detalheComponent: DetalheLimitePrazo,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_ANALISE_SUPERVISOR", label: "Análise do Supervisor" },
            { codigo: "ETAPA_3_ANALISE_FINANCEIRO", label: "Análise do Financeiro" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE_SUPERVISOR: { component: EtapaPromocaoAnalise, props: {} },
            ETAPA_3_ANALISE_FINANCEIRO: { component: EtapaLimitePrazoAnaliseFinanceiro, props: {} },
        },
    },
    CADASTRO_CLIENTE: {
        label: "Cadastro de Cliente",
        icone: "fa fa-id-card",
        service: new CadastroClienteService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoCadastroClienteForm,
        detalheComponent: DetalheCadastroCliente,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_ANALISE_SUPERVISOR", label: "Análise do Supervisor" },
            { codigo: "ETAPA_3_INFORMACOES_FINANCEIRAS", label: "Informações Financeiras" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE_SUPERVISOR: { component: EtapaPromocaoAnalise, props: {} },
            ETAPA_3_INFORMACOES_FINANCEIRAS: { component: EtapaCadastroClienteFinanceiro, props: {} },
        },
    },
    AJUSTE_GTC_ROTA_VISITA: {
        label: "Ajuste de GTC / Visita / Rota (Sub-Canal)",
        icone: "fa fa-route",
        service: new AjusteGtcService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoAjusteGtcForm,
        detalheComponent: DetalheAjusteGtc,
        etapas: [
            { codigo: "ETAPA_1_SOLICITACAO", label: "Solicitação" },
            { codigo: "ETAPA_2_ANALISE_SUPERVISOR", label: "Análise do Supervisor" },
            { codigo: "ETAPA_3_ANALISE_COMERCIAL", label: "Análise Comercial" },
            { codigo: "ETAPA_4_CADASTRO_ALTERACAO", label: "Cadastro/Alteração" },
        ],
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaSolicitacaoRetificada, props: {} },
            ETAPA_2_ANALISE_SUPERVISOR: { component: EtapaAprovacaoGestor, props: {} },
            ETAPA_3_ANALISE_COMERCIAL: { component: EtapaAprovacaoGestor, props: {} },
            ETAPA_4_CADASTRO_ALTERACAO: { component: EtapaAjusteGtcCadastroAlteracao, props: {} },
        },
        sugestoes: ["Foto do PDV Externo", "Foto do PDV Interno"],
    },
    RENOVACAO_GDM: {
        label: "Renovação de GDM",
        icone: "fa fa-snowflake",
        service: new RenovacaoGdmService(),
        temDetalhe: true,
        formularioCriacao: NovaSolicitacaoRenovacaoGdmForm,
        detalheComponent: DetalheRenovacaoGdm,
        etapas: ETAPAS_RENOVACAO_GDM,
        etapaComponents: {
            ETAPA_1_SOLICITACAO: { component: EtapaRenovacaoGdmSolicitacao, props: {} },
            ETAPA_2_APROVACAO: { component: EtapaRenovacaoGdmAprovacao, props: {} },
            ETAPA_3_CONFIRMACAO_RENOVACAO: { component: EtapaRenovacaoGdmConfirmacao, props: {} },
        },
        sugestoes: DOCUMENTOS_OBRIGATORIOS_RENOVACAO_GDM,
    },
};

export function processoInfo(tipoProcesso) {
    return PROCESSO_REGISTRY[tipoProcesso] || null;
}

const DEPARTAMENTO_REGISTRY = {
    SUPRIMENTOS: { label: "Suprimentos", icone: "fa fa-boxes" },
    LOGISTICA: { label: "Logística", icone: "fa fa-truck" },
    RH: { label: "RH", icone: "fa fa-user-tie" },
    ATIVOS: { label: "Ativos", icone: "fa fa-boxes-stacked" },
    FINANCEIRO: { label: "Financeiro", icone: "fa fa-balance-scale" },
};

export function departamentoInfo(departamento) {
    return DEPARTAMENTO_REGISTRY[departamento] || { label: departamento, icone: "fa fa-folder" };
}

export function etapaLabel(tipoProcesso, etapaCodigo) {
    const etapa = processoInfo(tipoProcesso)?.etapas.find(e => e.codigo === etapaCodigo);
    return etapa?.label || null;
}

export function etapaComponentInfo(tipoProcesso, etapaCodigo) {
    return processoInfo(tipoProcesso)?.etapaComponents?.[etapaCodigo] || null;
}

// % de avanço no fluxo, usado em Minhas Solicitações.
export function percentualFluxo(tipoProcesso, etapaAtualCodigo, status) {
    const etapas = processoInfo(tipoProcesso)?.etapas || [];
    if (etapas.length === 0) return 0;
    if (status === "FINALIZADA") return 100;

    const indice = etapas.findIndex(e => e.codigo === etapaAtualCodigo);
    if (indice === -1) return status === "CANCELADA" ? 100 : 0;
    return Math.round(((indice + 1) / etapas.length) * 100);
}
